'use client';

import React from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import IaButton from '@/components/common/webteam/IaButton/IaButton';
import DebugDropdown from '@/components/common/webteam/IaSiteHeader/parts/DebugDropdown';
import LoginLogoutButton from '@/components/common/webteam/IaSiteHeader/parts/LoginLogoutButton';
import ProfileButton from '@/components/common/webteam/IaSiteHeader/parts/ProfileButton';
import IaTypography from '@/components/common/webteam/IaTypography/IaTypography';
import { DJANGO_ADMIN_URL } from '@/consts/common';
import { UserRole } from '@/enums/users';
import { useStores } from '@/hooks';
import { useMenuItems } from '@/hooks/menu';
import { isDebug } from '@/utils/common';

import styles from './HeaderMenu.module.scss';

const HeaderMenu: React.FC = () => {
  const { userStore } = useStores();
  const me = userStore.me;
  const isSignedIn = !!me;

  const pathname = usePathname();

  const menuItems = useMenuItems();

  return (
    <>
      {menuItems.map(({ title, href }) => (
        <Link href={href} key={href}>
          <IaTypography
            className={clsx(
              styles.link,
              pathname.includes(href) && styles.active,
            )}
            key={title}
            params={{ mode: 'clear' }}
            theme="dark"
            variant="rs-link"
          >
            {title}
          </IaTypography>
        </Link>
      ))}

      {isSignedIn && <ProfileButton />}

      <LoginLogoutButton />

      {isDebug() && <DebugDropdown />}
      {!isDebug() && me?.role === UserRole.ADMIN && (
        <Link href={DJANGO_ADMIN_URL}>
          <IaButton mode="rock" theme="dark">
            Admin
          </IaButton>
        </Link>
      )}
    </>
  );
};

export default observer(HeaderMenu);
